import { render } from "./IconHierarchy.vue?vue&type=template&id=2444f404&scoped=true"
import script from "./IconHierarchy.vue?vue&type=script&lang=js"
export * from "./IconHierarchy.vue?vue&type=script&lang=js"

import "./IconHierarchy.vue?vue&type=style&index=0&id=2444f404&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2444f404"]])

export default __exports__